import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ProductNavigation = () => {
  const { t } = useTranslation();
  const location = useLocation();

  // Usar useMemo para evitar recálculos innecesarios
  const activePath = useMemo(() => {
    const path = location.pathname;
    if (path.startsWith('/producto/')) return '/producto/dollaro';
    return path;
  }, [location.pathname]);

  // Función para determinar si el enlace está activo
  const isActive = (path) => activePath === path;

  // Estilos base para los botones
  const baseStyles = 'px-4 py-2 rounded-full text-xs md:text-sm font-medium whitespace-nowrap';
  const activeStyles = 'bg-red-600 text-white shadow-lg';
  const inactiveStyles = 'bg-gray-800 hover:bg-gray-700 text-gray-300';

  return (
    <div className="bg-black py-3 sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-center space-x-2 md:space-x-4">
          <Link
            to="/producto/dollaro"
            className={`${baseStyles} ${isActive('/producto/dollaro') ? activeStyles : inactiveStyles}`}
          >
            {t('home.dollaroNappaBtn')}
          </Link>
          <Link
            to="/automotriz"
            className={`${baseStyles} ${isActive('/automotriz') ? activeStyles : inactiveStyles}`}
          >
            {t('home.automotiveBtn')}
          </Link>
          <Link
            to="/guantes-box"
            className={`${baseStyles} ${isActive('/guantes-box') ? activeStyles : inactiveStyles}`}
          >
            {t('home.boxingGlovesBtn')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProductNavigation);